import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getFormMode } from "../../../../lib/helpers";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import { z } from "zod";
import {
  Checkbox, FormControlLabel, FormGroup, Typography,
  FormLabel, FormControl, RadioGroup, Radio
} from "@mui/material";
import {
  insertTransportPlan,
  retriveTransportPlan,
  updateTransportPlan,
} from "../../../../Api/TransportPlanMst/Api";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import { useReactToPrint } from "react-to-print";
import axiosInstance from "../../../../lib/axios";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'TransPlanName', label: 'Transport', minWidth: 100 },
  { id: 'Descrition', label: 'Description', minWidth: 100 },
  { id: 'Amount', label: 'Amount', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 },
];

const FORM_MODE = getFormMode();
const FORM_INIT_STATE = {
  TransPlanName: "",
  Amount: "",
  Descrition: "",
  Remark: "",
  Status: "1",
  IsSplit: "Y"
};

const transportFormSchema = z.object({
  TransPlanName: z.string().min(1, "Transport Plan Name is required"),
  Amount: z.string().min(1, "Amount is reqired"),
  Descrition: z.string().optional(),
  Remark: z.string().optional(),
  Status: z.enum(["1", "0"]).optional(),
  IsSplit: z.string().optional()
});

const TransportPlan = () => {
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const [dataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState(FORM_INIT_STATE);
  const [currentTransPlanID, setCurrentTransPlanID] = useState(() => {
    return location?.state?.TransPlanID;
  });
  const [mode, setMode] = useState(() =>
    currentTransPlanID ? FORM_MODE.read : FORM_MODE.add
  );
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
    setForm((prevData) => ({
      ...prevData,
      Status: updatedStatus,
    }));
  };

  // Dashboard for printing the data
  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 0,
        PageSize: 10,
        SearchText: "",
      };
      try {
        const res = await axiosInstance.post('MstTransPlan/GetMstTransPlanDashBoard', { params });
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
    getRow();
  }, []);

  //For Retrive
  useEffect(() => {
    if (currentTransPlanID) {
      fetchTransPlanData();
    }
  }, []);

  const handlePrevious = async () => {
    if (!currentTransPlanID && currentTransPlanID < 1) return;
    await fetchTransPlanData("P");
  };

  const handleNext = async () => {
    if (!currentTransPlanID) return;
    await fetchTransPlanData("N");
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
    }
  };
  const handleEdit = async () => {
    setMode(FORM_MODE.edit);
  };
  const handleAdd = () => {
    setMode(FORM_MODE.add);
    setForm(FORM_INIT_STATE);
  };
  const handleCancel = async (flag = "L") => {
    if (mode === FORM_MODE.add) {
      await fetchTransPlanData("L", 1);
    } else {
      await fetchTransPlanData("R");
    }
    setMode(FORM_MODE.read);
  };
  const handleExit = () => {
    navigate(`/transport-plan-table`);
  };
  const handleDelete = async () => {
    setOpenConfirmDialog(true);
  };
  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };
  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      await fetchTransPlanData("D");
      const response = await retriveTransportPlan({
        TransPlanID: currentTransPlanID,
        Flag: "D",
      });
      if (response instanceof Error) {
        return toast.error("Error: could not delete room");
      }
      const {
        data: { Status, Message, Data },
      } = response;
      if (Status === 0) {
        toast.success(Message, { autoClose: 1000 });
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 1000 });
        } else {
          toast.error(Message, { autoClose: 1000 });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchTransPlanData = async (flag = "R", TransPlanID = 1) => {
    const response = await retriveTransportPlan({
      TransPlanID: currentTransPlanID ?? TransPlanID,
      Flag: flag,
    });
    if (response instanceof Error) {
      return console.log(response.message);
    }
    const {
      data: { Status, responseStatusCode, Data, Message },
    } = response;
    if (
      Status === 0 &&
      responseStatusCode === 1 &&
      Data &&
      Array.isArray(Data)
    ) {
      const data = Data[0];
      setForm({
        // TransPlanID: data.TransPlanID,
        TransPlanName: data.TransPlanName,
        Amount: data.Amount ? String(data.Amount) : "",
        Descrition: data.Descrition,
        Remark: data.Remark,
        Status: data.Status,
        IsSplit: data.IsSplit
      });
      setStatus(data.Status.toString());
      setMode(FORM_MODE.read);
      setCurrentTransPlanID(data.TransPlanID);
    } else {
      console.log(Message);
    }
  };

  const handleSubmit = async () => {
    const result = transportFormSchema.safeParse(form);
    console.log("result", result.error);
    if (!result.success) {
      return toast.info("Please fill in all required inputs correctly.", {
        autoClose: 500,
      });
    }
    const { data } = result;

    const payload = {
      TransPlanName: data.TransPlanName,
      Amount: data.Amount ? data.Amount : 0,
      PytType: "0",
      Descrition: data.Descrition,
      Remark: data.Remark,
      Status: data.Status,
      IsSplit: data.IsSplit
    };

    let response;
    if (mode === FORM_MODE.edit && currentTransPlanID) {
      payload.TransPlanID = currentTransPlanID;
      payload.UpdatedBy = UserId;

      response = await updateTransportPlan(payload);
    } else {
      payload.CreatedBy = UserId;
      response = await insertTransportPlan(payload);
    }

    if (response instanceof Error) {
      toast.error("Error:Could not submit form");
    }
    const {
      data: { Status, Message },
    } = response;
    if (Status === 0) {
      setMode(FORM_MODE.read);
      toast.success(Message, {
        autoClose: 1000,
      });
    } else {
      console.error(Message);
    }
  };

  return (
    <>
      <ToastContainer />
      <Box className="form-container">
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: { xs: "none", sm: "block" },
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={
                  mode !== FORM_MODE.read ||
                  !currentTransPlanID ||
                  currentTransPlanID === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display: { xs: "none", sm: "block" },
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== FORM_MODE.read}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Addon1 Master
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Addon1"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === FORM_MODE.read}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            className="form_field"
            sx={{ marginInline: { xs: "10px", sm: "80px" } }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="transPlanName"
                      name="TransPlanName"
                      label={
                        <span>
                          Plan Name
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.TransPlanName}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="amount"
                      name="Amount"
                      label={
                        <span>
                          Amount<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.Amount}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="description"
                      name="Descrition"
                      label="Description"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.Descrition}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="remark"
                      name="Remark"
                      label="Remark"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.Remark}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={mode === FORM_MODE.read}
                            checked={Status === "1"}
                            onChange={handleChangeStatus}
                          />
                        }
                        label="Status"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                  <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '18px' }}>
                    <Grid item>
                      <FormLabel component="legend">Split</FormLabel>
                    </Grid>

                    <Grid item>
                      <FormControl component="fieldset">
                        <RadioGroup
                          aria-label="IsSplit"
                          name="IsSplit"
                          value={form.IsSplit}
                          onChange={handleInputChange}
                          row
                        >
                          <FormControlLabel
                            value="Y"
                            control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                            label="Yes"
                            className="custom-textfield"
                            disabled={mode === FORM_MODE.read}
                          />
                          <FormControlLabel
                            value="N"
                            control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                            label="No"
                            className="custom-textfield"
                            disabled={mode === FORM_MODE.read}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === FORM_MODE.read && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(dataForPrint).length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Addon1 Records"
            contentRef={contentRef}
            customStyles={{ backgroundColor: '#f5f5f5' }}
          />
        )}
      </div>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TransportPlan;
